import react, { useEffect, useState } from 'react'
import './style.css'
import { BritishIcon, CheckBoxIcon,Checkmark,CrownWhite, ScanStatsIcon, Zipper, WordsIcon } from '../../../../elements/icons'
import { formatBigNumbers } from '../../../../elements/currentPlan'
import { Modal, Popover } from 'antd'
import {logEvent} from "../../../../utils";
import { PremiumModal } from './PremiumModal'
import { Button, SecondaryButton } from '../../Login'
import {useStores} from "stores/root";
import {IUserSettings} from "types";
import {observer} from "mobx-react-lite";
import Switcher from '../../../../elements/Switcher'

interface ICircleProgress{
    progress: number;
    wordsUsedSimple: number;
    wordsUsedDeep?: number;
    deepProgress?: number;
}

const PopoverContent: react.FC<{deep: boolean, wordsUsed: number}> = (props) => {
    const {deep, wordsUsed} = props;
    return <div className='popover__container'>
        <span className='popover__header'>{deep ? 'Deep scan' : 'Simple scan'}</span>
        <span className='popover__content'>
            <span className='popover__content-words'>{wordsUsed}</span> words
        </span>
    </div>
}

const CircleProgressBar: react.FC<ICircleProgress> = (props) => {
    return <svg width="250" height="250" viewBox="0 0 250 250" className='circular-progress' style={{'--progress': props.progress, '--progress-deep': props.deepProgress} as any}>
        <g transform='scale(0.224)'>
        <circle className="bg"
            cx="125" cy="125" r="115" fill="none" stroke="rgba(238, 240, 242, 1)" strokeWidth="20"
        ></circle>
        {
            props.wordsUsedSimple ? <Popover content={<PopoverContent deep={false} wordsUsed={props.wordsUsedSimple}/>} color='white' overlayStyle={{whiteSpace: 'pre-line'}}>
          <circle className="fg"
              cx="125" cy="125" r="30" fill="none" stroke="rgba(158, 176, 255, 1)" strokeWidth="20"
          ></circle>
        </Popover> : null
        }
        {
            props.wordsUsedDeep ? <Popover content={<PopoverContent deep={true} wordsUsed={props.wordsUsedDeep}/>} color='white'>
          <circle className="deep"
              cx="125" cy="125" r="30" fill="none" strokeWidth="20"
          ></circle>
        </Popover> : null
        }
        </g>
    </svg>
}

const CurrentPlanContainer: react.FC = () => {
    return <div className='current__plan-widget'>Current plan</div>
}

const PopularContainer: react.FC = () => {
    return <div className='popular__container'>
        <Zipper />
        <span className='popular__cotnainer-text'>Popular</span>
    </div>
}

interface IPremiumCircleStats{
    wordsUsedSimple: number;
    wordsUsedDeep?: number;
    grantedSimple: number;
    grantedDeep?: number;
    header: string | React.ReactNode;
}

export const PremiumStatisticCircle: react.FC<IPremiumCircleStats> = (props) => {
    const {wordsUsedSimple, wordsUsedDeep, grantedSimple, grantedDeep, header} = props;
    return <div className="statistics__circle">
            <div className="circle">
                <div style={{transform: 'scale(0.2)'}}></div>
                <CircleProgressBar 
                    progress={wordsUsedSimple / grantedSimple * 100} 
                    deepProgress={wordsUsedDeep && grantedDeep ? wordsUsedDeep / grantedDeep * 100 : undefined}
                    wordsUsedSimple={wordsUsedSimple}
                    wordsUsedDeep={wordsUsedDeep}
                />
            </div>
            <div className="circle-info">
                <div className="circle-active-words premium__header">
                    {header}
                </div>
                <div className="circle-disabled-words">
                {formatBigNumbers((wordsUsedSimple || 0).toString())}<span className='circle-disabled__words'>/{formatBigNumbers((grantedSimple || 0).toString())} words</span>
                </div>
            </div>
        </div>
}

interface IPremiumStats{
    wordsUsedSimple: number;
    wordsUsedDeep: number;
    grantedSimple: number;
    grantedDeep: number;
    britishUsed: number;
    britishGranted: number;
    isPremium: boolean;
}
const PremiumStatisticsContainer: react.FC<IPremiumStats> = (props) => {
    const {wordsUsedSimple, wordsUsedDeep, grantedSimple, grantedDeep, britishUsed, britishGranted, isPremium} = props;
    try{
        return <div className='premium-stats__container'>
        <PremiumStatisticCircle
            wordsUsedSimple={wordsUsedSimple}
            wordsUsedDeep={wordsUsedDeep}
            grantedSimple={grantedSimple}
            grantedDeep={grantedDeep}
            header={<div className='premium__header-container'>
                <ScanStatsIcon />
                <span>Scan words used</span>
            </div>}
        />
        <PremiumStatisticCircle
            wordsUsedSimple={britishUsed}
            grantedSimple={britishGranted}
            header={<div className='premium__header-container'>
                <BritishIcon />
                <span>Britishizer words used</span>
            </div>}
        />
        <div className="current__plan">
            <span>Current plan</span>
            <button className={ (isPremium ? 'primary' : 'secondary free-plan-btn ') + ' current-plan-btn'}>
                {
                    isPremium ? <CrownWhite /> : <></>
                }
                <span>
                    {
                        isPremium ? 'Premium' : 'Free'
                    }
                </span>
            </button>
        </div>
    </div>
    } catch(e) {
        return <div></div>
    }
}

interface ICheckInfoText{
    text: string;
}
const CheckInfoContainer: react.FC<ICheckInfoText> = (props) => {
    const {text} = props;
    return <div className='prem-checkbox__container' style={{opacity: text === '' ? 0 : 1}}>
        <CheckBoxIcon />
        <span dangerouslySetInnerHTML={{__html: text}} style={{maxWidth: "200px"}}></span>
    </div>
}


interface IPlanContainer{
    name: string;
    pricing: string;
    plans: string[];
    isPremium: boolean;
    owned: boolean;
    onClick: () => void;
}
const PlanContainer: react.FC<IPlanContainer> = (props) => {
    const {name, pricing, plans, isPremium, owned} = props;
    return <div className='plan__container'>
        <span className="container__type">
            {
                isPremium ? <PopularContainer /> : <div/>
            }
            <span>{name}</span>
            {
                isPremium ? <div style={{width: 117}}></div> : <div/>
            }
        </span>
        <span className="container__type-price">
            <span>{pricing}</span>
            {
                owned ? <CurrentPlanContainer /> : <></>
            }
        </span>
        <div className="check__containers">
            {
                plans.map(e => <CheckInfoContainer text={e}/>)
            }
        </div>
        {isPremium ? (
            <Button  
                className={'plan__container-btn'}
                disabled={owned}
                onClick={() => {
                    props.onClick();
                    if (isPremium) {
                        logEvent('subscription__premium_get_started');
                    } else {
                        logEvent('subscription__basic_get_started');
                    }
                }}
            >
                {owned ? 'Current plan' : 'Get started'}
            </Button>
        ) : (
            <SecondaryButton
                className={'plan__container-btn'}
                disabled={owned}
                onClick={() => {
                    props.onClick();
                    if (isPremium) {
                        logEvent('subscription__premium_get_started');
                    } else {
                        logEvent('subscription__basic_get_started');
                    }
                }}
            >
                {owned ? 'Current plan' : 'Get started'}
            </SecondaryButton>
        )}
    </div>
}


interface ISubsModal{
    open: boolean;
    setOpen: (state: boolean) => void;
}
export const SubscribeRequestSent: react.FC<ISubsModal> = (props) => {
    return <Modal
        open={props.open}
        footer={''}
        width={400}
        onCancel={() => {props.setOpen(false)}}
        closable={true}
    >
        <div className='sm__container'>
             <span className="subscribe-modal__header">
                <span>Request sent</span>
                <Checkmark />
            </span>
            <span className="subscribe-modal__content">
            Thank you for joining us! Your premium subscription has been activated.
            Please complete the payment within 3 days to avoid deactivation.
            </span>
            <button className='secondary sm__request' onClick={() => props.setOpen(false)}>OK</button>
        </div>
    </Modal>
}


interface IPersonalCard {
    title?: string;
    price?: string;
    period?: string;
    wordCount?: string;
    features?: string[];
    description?: {
        type: "primary" | "highlight" | "secondary";
        text: string;
    };
    buttonDisabled?: boolean;
    onClick?: () => void;
}

interface IEnterpriseCard extends IPersonalCard {
    featuresRight?: string[];
    featuresLeft?: string[];
}

const PersonalCard: React.FC<IPersonalCard> = ({
    title = "Free",
    price = "$0", 
    period = "/month",
    wordCount = "10,000 words",
    features = [
        "10 free <strong>Deep scans</strong>",
        "Characters limit: <strong>5,000</strong>",
        "Chrome Extension"
    ],
    description = {'text': '_', type: "common"},
    buttonDisabled = false,
    onClick = () => {}
}) => {

    return (
        <div className='personal-card'>
            <div className='personal-card__title-container'>
                <span className='personal-card__title'>{title}</span>
                {
                    title === 'Premium' ? <PopularContainer /> : <></>
                }
            </div>
            <div className='personal-card__price'>
                <span className='personal-card__price-amount'>{price}</span>
                <span className='personal-card__price-period'>{period}</span>
            </div>
            <span className={
                'personal-card__description-container ' +
                (description.text == '_' ? ' description-invisible ' : '') +
                (description.type == 'highlight' ? 'personal-card__description-highlight' : "") + 
                (description.type == 'secondary' ? 'personal-card__description-secondary': '')
            }>{description.text}</span>
            <hr className='personal-card__divider' />
            <div className='personal-card__words'>
                <WordsIcon />
                <span className='personal-card__words-text'>{wordCount}</span>
            </div>
            <hr className='personal-card__divider' />
            <div className="check__containers">
                {
                    features.map(e => <CheckInfoContainer text={e}/>)
                }
            </div>
            <div className="personal-card__button-wrapper">
                <SecondaryButton 
                onClick={() => {
                    onClick();
                }}
                disabled={buttonDisabled}
                >
                    Get started
                </SecondaryButton>
            </div>
        </div>
    );
}

const EnterpriseCard: React.FC<IEnterpriseCard> = ({
    title, 
    price, 
    period, 
    wordCount, 
    featuresRight, 
    featuresLeft, 
    description, 
    buttonDisabled,
    onClick = () => {}
}) => {

    return (
        <div className='personal-card personal-enterprise-card'>
            <div className='personal-card__title'>{title}</div>
            <div className='personal-card__price'>
                <span className='personal-card__price-amount'>{price}</span>
                <span className='personal-card__price-period'>{period}</span>
            </div>
            <span className={
                'personal-card__description-container ' +
                (description!.text == '_' ? ' description-invisible ' : '') +
                (description!.type == 'highlight' ? 'personal-card__description-highlight' : "") + 
                (description!.type == 'secondary' ? 'personal-card__description-secondary': '')
            }>{description!.text}</span>
            <hr className='personal-card__divider' />
            <div className='personal-card__words'>
                <WordsIcon />
                <span className='personal-card__words-text'>{wordCount}</span>
            </div>
            <hr className='personal-card__divider' />
            <div className='check__container-enterprice'>
                <div className="check__containers">
                    {
                        featuresLeft!.map(e => <CheckInfoContainer text={e}/>)
                    }
                </div>
                <div className="check__containers">
                    {
                        featuresRight!.map(e => <CheckInfoContainer text={e}/>)
                    }
                </div>
            </div>
            
            <div className="personal-card__button-wrapper">
                <Button onClick={() => {
                    onClick();
                }} disabled={buttonDisabled}>Get started</Button>
            </div>
        </div>
    );
}

export const PremiumPage: React.FC = observer(() => {
    const [modalOpen, setModalOpen] = useState(false);
    const [subscribeModalOpen, setSubscribeModalOpen] = useState(false);
    const { user: useStore } = useStores()
    const user = useStore.user as IUserSettings | null
    const [plan, setPlan] = useState("yearly");
    const [planName, setPlanName] = useState('');
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const forceStart = params.get('force-start');
        
        if (forceStart === 'true') {
            setModalOpen(true);
        }
    }, []);
    return <div className='premium__page__container'>
        <PremiumModal open={modalOpen} onOk={() => {
                setModalOpen(false);
                setSubscribeModalOpen(true)
                logEvent("premium__send_request");
                logEvent("subscription__" + planName + "__get_started");
            }}
            onCancel={() => {
                setModalOpen(false)
                logEvent("subscription_form__close");
            }}
            planName={planName}
        />
        <SubscribeRequestSent
            open={subscribeModalOpen}
            setOpen={setSubscribeModalOpen}
        />
        <div className="sized">
            <div className="premium__header">Subscription</div>
            <PremiumStatisticsContainer 
                wordsUsedSimple={user?.used_words_simple_scan || 0} 
                wordsUsedDeep={user?.used_words_deep_scan || 0} 
                grantedSimple={user?.granted_words_simple_scan || 0} 
                grantedDeep={user?.granted_words_deep_scan || 0} 
                isPremium={user?.subscription !== 'Free'}
                britishUsed={user?.used_british_words || 0}
                britishGranted={user?.granted_british_words || 0}
            />
            <div className="premium__header-container1">
                <div className="premium__header">
                    Manage plans
                </div>
                <div style={{width: 384}}>
                    <Switcher 
                    options={[
                        {label: <div className='switcher-class'>Monthly</div>, value: 'monthly'}, 
                        {label: <div className='switcher-class'>Yearly <span className='colored'>(save 20%)</span></div>, value: 'yearly'}
                    ]} 
                    value={plan} 
                    onChange={(e) => {setPlan(e)}}
                />
                </div>
                <div style={{width: 155}}></div>
            </div>
            <span className='plans__header'>Personal</span>
            <div className="plans">
                <PersonalCard 
                    buttonDisabled={user?.subscription === 'Free'}
                />
                <PersonalCard 
                    title="Pay as you go"
                    price="$30"
                    period="/pack"
                    wordCount='300,000 words'
                    features={[
                        "All in <strong>free</strong>",
                        "Characters limit: <strong>100,000</strong>",
                        "Deep scan mode",
                        "Doc upload",
                        "30-day history",
                        "Usage statistic",
                        "Sharable reports",
                        "Plagiarism checker",
                        "Document limit: <strong>5 mb</strong>"
                    ]}
                    description={{type: 'primary', text: 'On-demand 2-years pack'}}
                    buttonDisabled={user?.subscription === 'Pay as you go'}
                    onClick={() => {
                        setPlanName('Pay as you go');
                        setModalOpen(true);
                    }}
                />
                <PersonalCard 
                    title="Premium"
                    price={plan === 'monthly' ? "15$" : "12$"}
                    period="/month"
                    wordCount="300,000 words"
                    features={[
                        "All in <strong>Pay as you go</strong>",
                        "Britishizer words: <strong>25,000</strong>",
                        "ChatGpt plugin",
                        "Batch doc upload: up to <strong>25 files</strong> (coming soon)",
                        "Plagiarism checker (coming soon)",
                        "Document limit: <strong>25mb</strong>"
                    ]}
                    description={
                        plan === 'monthly' ? {type: 'highlight', text: '_'} : {type: 'highlight', text: 'Save $60/year'}
                    }
                    buttonDisabled={user?.subscription === 'Premium'}
                    onClick={() => {
                        setPlanName('Premium');
                        setModalOpen(true);
                    }}
                />
                <PersonalCard
                    title="Pro"
                    price={plan === 'monthly' ? "$25" : "$20"}
                    period="/month"
                    wordCount="500,000 words"
                    features={[
                        "All in <strong>Pay as you go</strong>",
                        "Britishizer words: <strong>50,000</strong>",
                        "ChatGpt plugin",
                        "Batch doc upload: up to <strong>50 files</strong> (coming soon)",
                        "Plagiarism checker (coming soon)",
                        "Document limit: <strong>50mb</strong>"
                    ]}
                    description={
                        plan === 'monthly' ? {type: 'highlight', text: '_'} : {type: 'highlight', text: 'Save $60/year'}
                    }
                    buttonDisabled={user?.subscription === 'Pro'}
                    onClick={() => {
                        setPlanName('Pro');
                        setModalOpen(true);
                    }}
                />
            </div>
            <span className='plans__header'>Enterprise</span>
            <div className="plans">
                <EnterpriseCard 
                    title="Enterprise"
                    price="$75"
                    period="/month"
                    wordCount="From 1M to 100M words"
                    featuresLeft={[
                        "All in <strong>Premium</strong>",
                        "Britishizer words: <strong>100,000</strong>",
                        "365-day history", 
                        "Batch doc upload: up to <strong>250</strong> files",
                        "Document limit: <strong>100mb</strong>"
                    ]}
                    featuresRight={[
                        "Pay as you go for <strong>$7.5/100,000</strong> words",
                        "500,000 characters limit",
                        "Priority support",
                        "API access"
                    ]}
                    description={{type: 'highlight', text: 'Save $120+/year'}}
                    buttonDisabled={user?.subscription === 'Enterprise'}
                    onClick={() => {
                        setPlanName('Enterprise');
                        setModalOpen(true);
                    }}
                />
                <EnterpriseCard 
                    title="Educational Institution"
                    price="$5"
                    period="/student per year"
                    wordCount="500k words/month per teacher"
                    featuresLeft={[
                        "Give Pro subscription to every teacher",
                        "All in one solution for monitoring authenticity of students work"
                    ]}
                    featuresRight={[
                        "Google Classroom integration included (coming soon)",
                        "Moodle integration included (coming soon)",
                        "Priority support"
                    ]}
                    description={{type: 'secondary', text: 'No monthly subscription'}}
                    buttonDisabled={user?.subscription === 'Educational Institution'}
                    onClick={() => {
                        setPlanName('Educational Institution');
                        setModalOpen(true);
                    }}
                />
            </div>
        </div>
    </div>
})